import { NotaPromissoria } from "../types";

/** Antecedência, em dias, com que uma NP prestes a vencer entra no alerta global. */
export const ANTECEDENCIA_ALERTA_DIAS = 15;

export type SituacaoNp = "baixada" | "vencida" | "a_vencer" | "em_dia";

/** Hoje em São Paulo como YYYY-MM-DD (en-CA já dá esse formato), sem deslocamento de fuso. */
export const hojeSaoPaulo = (): string =>
  new Date().toLocaleDateString("en-CA", { timeZone: "America/Sao_Paulo" });

const utcDe = (iso: string): number => {
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  return Date.UTC(y, m - 1, d);
};

/** Dias até o vencimento: negativo quando já venceu. */
export const diasParaVencimento = (dataVencimento: string, hoje = hojeSaoPaulo()): number =>
  Math.round((utcDe(dataVencimento) - utcDe(hoje)) / 86_400_000);

export function situacaoNp(
  np: Pick<NotaPromissoria, "data_vencimento" | "baixado">,
  hoje = hojeSaoPaulo()
): { situacao: SituacaoNp; dias: number } {
  const dias = diasParaVencimento(np.data_vencimento, hoje);
  if (np.baixado) return { situacao: "baixada", dias };
  if (dias < 0) return { situacao: "vencida", dias };
  if (dias <= ANTECEDENCIA_ALERTA_DIAS) return { situacao: "a_vencer", dias };
  return { situacao: "em_dia", dias };
}

/** Separa, entre as NPs não baixadas, as vencidas e as que vencem em até 15 dias. */
export function resumoAlerta(notas: NotaPromissoria[], hoje = hojeSaoPaulo()) {
  const vencidas: NotaPromissoria[] = [];
  const aVencer: NotaPromissoria[] = [];
  for (const np of notas) {
    const { situacao } = situacaoNp(np, hoje);
    if (situacao === "vencida") vencidas.push(np);
    else if (situacao === "a_vencer") aVencer.push(np);
  }
  return { vencidas, aVencer };
}

/** Termo de cessão, NP e CNAB de remessa já gerados pela imagem R. */
export const documentosProntos = (np: NotaPromissoria): boolean =>
  Boolean(np.termo_cessao_key_path && np.termo_np_key_path && np.cnab_remessa_key_path);

/**
 * O CNAB de baixa sai por um download próprio, então a prontidão dele não
 * depende dos documentos da compra: uma NP pode ter a baixa pronta com um
 * documento de compra pendente, e vice-versa.
 */
export const cnabBaixaPronto = (np: NotaPromissoria): boolean =>
  Boolean(np.cnab_baixa_key_path);

export const formatarCentavos = (centavos: number): string =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(centavos / 100);
